import { IUserInfo } from "Src/Types/ReDoc/Auth";
import API from "src/API";

type RdcUserInfo = IUserInfo | null;

class RedocUser {

	static user: RdcUserInfo = null;
	static controller: AbortController | null = null;

	static possibleRoleDict = {
		MfcOperator: "rl_opm",
		mfcOperator: "rl_opm",
		MfcController: "rl_ktm",
		mfcController: "rl_ktm",
		MfcMainController: "rl_gkt",
		mfcMainController: "rl_gkt",
		Admin: "rl_adm",
		admin: "rl_adm",
		AdminRegion: "rl_admregion",
		adminRegion: "rl_admregion",
		OivOperator: "rl_opoiv",
		oivOperator: "rl_opoiv",
		OivMainOperator: "rl_opmainoiv",
		oivMainOperator: "rl_opmainoiv",
		OivHead: "rl_oivhead",
		oivHead: "rl_oivhead",
		Courier: "rl_courier",
		courier: "rl_courier",
		Consultant: "rl_consm",
		consultant: "rl_consm",
		PzAdmin: "rl_pzadmin",
		pzAdmin: "rl_pzadmin",
		PzOperator: "rl_pzoperator",
		pzOperator: "rl_pzoperator",
		RpguConsultant: "rl_consrpgu",
		rpguConsultant: "rl_consrpgu",
		AdminOMSU: "rl_adminomsu",
		adminOMSU: "rl_adminomsu",
		BranchHead: "rl_branchhead",
		branchHead: "rl_branchhead",
		Outsider: "rl_outsider",
		outsider: "rl_outsider",
	};	

	static possibleRoles = [
		"rl_opm",
		"rl_ktm",
		"rl_gkt",
		"rl_adm",
		"rl_admregion",
		"rl_opoiv",
		"rl_opmainoiv",
		"rl_oivhead",
		"rl_courier",
		"rl_consm",
		"rl_pzadmin",
		"rl_pzoperator",
		"rl_consrpgu",
		"rl_adminomsu",
		"rl_branchhead",
		"rl_outsider",
	];

	static oivRoles = [
		'rl_opoiv','rl_opmainoiv','rl_oivhead'
	];	

	static mfcRoles = [
		'rl_opm','rl_ktm','rl_gkt','rl_consm'
	];
	
	static isMfc = () => {
		this.userInfo()
			.then( user => {
				const result = user?.roles.filter( item => this.mfcRoles.indexOf(item) > -1 );
				return !!result?.length;
			})
			.catch( e => {
				console.warn(e);
				throw new Error( 'Не удалось получить данные пользователя.' );
			});
	};	
	
	static isOiv = () => {
		this.userInfo()
			.then( user => {
				const result = user?.roles.filter( item =>this.oivRoles.indexOf(item) > -1 );
				return !!result?.length;
			})
			.catch( e => {
				console.warn(e);
				throw new Error( 'Не удалось получить данные пользователя.' );
			});
	};

	static hasRole = ( role: string ) => {
		if ( !!this.user && !!this.user.roles && this.user.roles.length > 0 ) {
			for ( let i = 0; i < this.user.roles.length; i++ ) {
				const roleItem = this.user.roles[i];
				if ( roleItem === role ) {
					return true;
				}
			}
		}
		return false;
	};

	static hasRule = ( rule: string ) => {
		const user = this.user;
		let result = false;
		if ( !!user ) {
			if ( !user.rules || user.rules.length === 0 ) {
				result = true;
			} 
			else {
				for ( let i = 0; i < user.rules.length; i++ ) {
					if ( user.rules[i] === rule ) {
						result = true;
						break;
					}
				}
			}
		}
		return result;
	};

	static isRegistryDenied = () => !!this.user?.rules && this.user.rules.indexOf('denyAll') > -1;

	static hasExternalRegistry = () => {
		if ( !!this.user?.rules ) {
			const withoutPrefix = this.user?.rules.filter( item => item.indexOf("Nvx.ReDoc") < 0 );
			return !!withoutPrefix?.length;
		}
		return false;
	};

	static updatedUserInfo = () => {
		this.user = null;
		return this.userInfo();
	};

	//Получение данных о пользователе.
	static userInfo = (): Promise<RdcUserInfo> => new Promise( ( resolve, reject ) => {

		if ( !!this.controller?.signal ) {
			this.controller.abort();
			this.controller = null;
		}

		if ( !!this.user ) {
			resolve( this.user );
		} 
		else {
			this.controller = new AbortController();
			API.Auth.getUserInfo( this.controller )
				.then( result => {
					this.user = result;
					resolve( result );
				})
				.catch( e => reject(e) )
				.finally( () => {
					this.controller = null;
				});
		};
	});

};


export default RedocUser;
